<template>
    <div id="app-container">
        <!-- Condición para ocultar el componente vue-step-progress en la ruta /gracias-cita-online -->
        <!-- Clinica: {{ $store.state.clinic }}<br>
        Tratamiento: {{ $store.state.treatment }}<br>
        Fecha: {{ $store.state.cita }}<br> -->
        <router-view></router-view>
        <!-- <vue-step-progress
            v-if="!isThankYouRoute"
            :current-step="currentStep"
            active-color="#2f3e4a"
            :active-thickness="3"
            :passive-thickness="3"
            :line-thickness="3"
            icon-class="check-icon"
            :steps="steps"
        /> -->
    </div>
</template>

<script>
//import VueStepProgress from "vue-step-progress";
//import "vue-step-progress/dist/main.css";

export default {
    name: "App",
    components: {
        //VueStepProgress,
    },
    data() {
        return {
            currentStep: 0,
            steps: ["Clínica", "Tipo de visita", "Fecha y Hora", "Datos"],
        };
    },
    computed: {
        isThankYouRoute() {
            return this.$route.path === "/gracias-cita-online";
        },
    },
    watch: {
        $route(to) {
            this.updateStepFromRoute(to.path);
        },
    },
    methods: {
        updateStepFromRoute(path) {
            const stepMap = {
                "/cita-online/centro/": 0,
                "/cita-online/tratamiento/": 1,
                "/cita-online/cita/": 2,
                "/cita-online/datos/": 3,
                "/gracias-cita-online/": 4,
            };
            this.currentStep = stepMap[path] !== undefined ? stepMap[path] : 0;
        },
    },
    created() {
        this.updateStepFromRoute(this.$route.path);
    },
};
</script>

<style>
@import "./assets/styles.css";

.check-icon {
    display: inline-block;
    width: 40px; /* Ajusta el tamaño según tus necesidades */
    height: 40px; /* Ajusta el tamaño según tus necesidades */
    background: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij4KICA8cGF0aCBmaWxsPSIjZmZmZmZmIiBkPSJNOSAxNi4xN2wtNC4xNy00LjE3LTEuNDEgMS40MUw5IDE5IDIwLjU5IDcuNDFsLTEuNDItMS40MXoiLz4KPC9zdmc+Cg==")
        no-repeat center center;
    background-size: contain;
}
.step-progress__bar {
    margin-bottom: 30px !important;
}
.step-progress__step-label {
    font-size: 0.8rem !important;
}
.step-progress__step:after {
    height: 40px !important;
    width: 40px !important;
}
.step-progress__step span {
    font-size: 28px !important;
}
</style>

<style>
:root {
    --blue-color: #2f3e4a;
    --pink-color: #f93f6e;
    --soft-pink-color: #eeb6c5;
    --light-pink-color: #fff0f5;
    --grey-color: #bdc5c9;
    --dark-grey-color: #a0a0a0;
}
h1,
h2,
h3,
h4,
h5,
p {
    color: var(--blue-color);
}
#app-container {
    max-width: 800px;
    margin: 0 auto;
    min-height: 80vh;
    margin-top: 0rem;
}

@media (min-width: 768px) {
    #app-container {
        margin-top: 1.5rem;
    }
}
</style>
